import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

const meta = {
	description: 'Without the community, there is no purpose #wearehereforyou',
	image: '/images/new/misc/blueshyft-meta.png',
	title: '2020 End of Year Wrap-Up | blueshyft',
	url: 'https://blueshyft.com.au/blog-2020endofyearwrapup',
};

import '../../css/about.css';

export default class About extends Component {
	render () {

		return (
			<React.Fragment>
				<Helmet
					title={meta.title}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.image },
					]}
				/>

				<section className="about-wrapup">
					<div className="container">
						<div className="photos-container">
							<div className="photos">
								<div className="photo">
									<img src="/images/blog-2020endofyearwrapup/w-jamie.png" alt="jamie" />
								</div>
								<div className="photo">
									<img src="/images/blog-2020endofyearwrapup/w-hooms.png" alt="hooms" className="photo" />
								</div>
								<div className="photo">
									<img src="/images/blog-2020endofyearwrapup/w-rhiannon.png" alt="rhiannon" className="photo" />
								</div>
								<div className="photo">
									<img src="/images/blog-2020endofyearwrapup/w-mike.png" alt="mike" className="photo" />
								</div>
							</div>
							<div className="photos">
								<div className="photo">
									<img src="/images/blog-2020endofyearwrapup/w-denis.png" alt="denis" className="photo"/>
								</div>
								<div className="photo">
									<img src="/images/blog-2020endofyearwrapup/w-barclay.png" alt="barclay" className="photo" />
								</div>
								<div className="photo">
									<img src="/images/blog-2020endofyearwrapup/w-rj.png" alt="rj" className="photo" />
								</div>
								<div className="photo">
									<img src="/images/blog-2020endofyearwrapup/w-louie.png" alt="louie" className="photo" />
								</div>
							</div>
						</div>
						<div className="sub-header">
							<div>Without the community, there is no purpose #wearehereforyou</div>
						</div>
					</div>
				</section>


				<section className="wrapup">
					<div className="block">
						<p>2020 has been a year like no other. From small smart-ups to major corporations, no one has had it easy. However, adversity presents opportunities, as long as they are utilised appropriately. When the pandemic initially hit, none of us here at blueshyft were aware of the devastating impact it would have on both consumers and businesses. With a NSW lockdown being officially enforced on March 31, the future was looking bleak and lacking in prosperity. Gradually, businesses have started to open up, and the Australian community has become increasingly optimistic for what’s to come.</p>
					</div>

					<div className="block">
						<h4>A brand new partner</h4>
						<p>Mid-way through the year, we partnered  with FedEx Express, who has now taken over TNT in Australia. Due to the increased demand for e-commerce products, coupled with the need for convenience from consumers, the logistics space is rapidly growing, with this trend set to continue into the future. In addition, the closure of many large retail chains has resulted in an increase in e-commerce shoppers due to the lack of physical retail presence.</p>
					</div>

					<div className="block">
						<h4>Wagering in 2020</h4>
						<p>In regards to the wagering industry, there has been substantial growth. Our major partner, Ladbrokes, has continued to impress both punters and partners, as they continue to grow month by month. Fortunately, major sporting events such as Spring Carnival 2020 and the NRL and AFL Grand Finals were able to go ahead, which has allowed both avid sport fans and punters to continue betting. These major sporting events, however, were not the sole reason for the growing numbers in the wagering sector. Due to national lockdowns and the closure of physical betting agencies, bettors turned to digital wagering services on mobile devices.</p>
					</div>

					<div className="block">
						<h4>WAYS Charity</h4>
						<p>Recently, we donated a number of iPads to a Sydney-based charity, WAYS. This charity primarily focuses on helping youth and their families  through specific initiatives such as personal development workshops, vocational counselling, and student wellbeing. We have donated these iPads to WAYS in order to facilitate improved learning to those who do not normally have access to it.</p>
					</div>

					<div className="block">
						<h4>Community focus</h4>
						<p>For us at blueshyft, adaptation and progression remain at the heart of our business model.  Our goal is to connect people - the community - to digital services by extending our presence of independent stores around the country. As such, the agent is critical in delivering our mission, as they act as facilitators for efficiency and convenience. The community is not only the most important element in our view, but also the reason for our work. We believe that without the community, there is no purpose.</p>
					</div>
				</section>

			</React.Fragment>
		);
	}
};



// WEBPACK FOOTER //
// ./client/scenes/blog-2020endofyearwrapup/index.js